import Image from '../images/values.jpg'
import SectionsHead from './SectionsHead'
import {GiCutDiamond} from 'react-icons/gi'
import { values } from '../data'
import Card from '../UI/Card'

const Values = () => {
  return (
    <section className='values'>
        <div className='container values_container'>
            <div className="values_left">
                <div className="values_image">
                    <img src={Image} alt="Values" />
                </div>
            </div>
            <div className="values_right">
                <SectionsHead icon={<GiCutDiamond/>} title="Add Your Values"/>
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. 
                     voluptatum natus voluptates aut debitis.</p>
                     <div className="values_wrapper">
                        {
                            values.map(({id, icon, title, desc}) => {
                                return <Card key={id} className="values_value">
                                    <span>{icon}</span>
                                    <h4>{title}</h4>
                                    <small>{desc}</small>
                                </Card>
                            })
                        }
                     </div>
            </div>
        </div>
    </section>
  )
}

export default Values